export default "__VITE_ASSET__DlIy9gee__"